import { render, staticRenderFns } from "./bandadrtion.vue?vue&type=template&id=66522ae6&scoped=true"
import script from "./bandadrtion.vue?vue&type=script&lang=js"
export * from "./bandadrtion.vue?vue&type=script&lang=js"
import style0 from "./bandadrtion.vue?vue&type=style&index=0&id=66522ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66522ae6",
  null
  
)

export default component.exports